const when = (iso) => (iso ? new Date(iso).toLocaleString([], { dateStyle: "medium", timeStyle: "short" }) : "");

export const BriefEmailStatus = ({ e, onDownload, prefix }) => {
  if (!e) return null;
  const sent = e.status === "sent";
  const attached = sent && e.mode === "attached";
  if (attached) return <p className="mt-1 text-sm text-emerald-300" data-testid={`${prefix}-email-status`}>Sent to {e.to} with the PDF attached{e.provider === "resend" ? " (via Resend)" : ""} · {when(e.at)}</p>;
  if (sent) return (
    <p className="mt-1 text-sm text-amber-300" data-testid={`${prefix}-email-status`}>
      Email sent to {e.to} without the PDF ({when(e.at)}). <button className="font-semibold underline" onClick={onDownload} data-testid={`${prefix}-email-download-link`}>Download it here.</button>
    </p>
  );
  return <p className="mt-1 text-sm text-red-300" role="alert" data-testid={`${prefix}-email-status`}>Not sent to {e.to} ({when(e.at)}): {e.error}</p>;
};
